import { z } from "zod";
import { ClinicImagingStudyAssociationSchema, ImagingOrderDestinationSelectionSchema, } from "./orders.js";
import { IdempotencyKeySchema, IdSchema, Sha256Schema } from "./primitives.js";
export const RegisterPrintableImagingFacilityCommandSchema = z
    .object({
    siteId: IdSchema,
    documentId: IdSchema,
    documentVersion: z.number().int().positive(),
    documentVersionHash: Sha256Schema,
    organizationName: z.string().trim().min(2).max(160),
    verificationNote: z.string().trim().min(10).max(2_000),
    verified: z.literal(true),
    studies: z.array(ClinicImagingStudyAssociationSchema).min(1).max(500),
    idempotencyKey: IdempotencyKeySchema,
})
    .strict();
export const PrintableImagingFacilityReceiptSchema = ImagingOrderDestinationSelectionSchema.extend({
    name: z.string().min(2).max(160),
    externalTransmissionEnabled: z.literal(false),
}).strict();
//# sourceMappingURL=imaging-facilities.js.map